import dayjs from "dayjs";
import React from "react";

interface ProcurementChecklistItemProps {
    item: any;
    section: "requireOnSite" | "leadtime" | "submit" | "approve" | "order" | "checkin" | "receive" | "deliver";
    project: any;
}

const DashboardProcurementChecklistItem: React.FC<ProcurementChecklistItemProps> = ({ item, section, project }) => {
    const itemDueDate = () => {
        switch (section) {
            case "requireOnSite":
                return dayjs();
            case "leadtime":
                return dayjs();
            case "submit":
                return dayjs(item.submit_by);
            case "approve":
                return dayjs(item.approve_by);
            case "order":
                return dayjs(item.order_by);
            case "checkin":
                return dayjs(item.checkin_by).endOf("week");
            case "receive":
                return dayjs();
            default:
                return dayjs();
        }
    };

    if (!item) {
        return null;
    }

    return (
        <div
            key={item.id}
            className="flex items-center justify-between text-white border-b border-solid border-gray-500"
        >
            <div className="w-1/6 text-sm text-center m-0.5 p-0.5">
                {item.team_avatar_url && (
                    <img src={item.team_avatar_url} alt={"team avatar"} className="w-6 h-6 rounded-full mx-auto" />
                )}
            </div>
            <div className="w-4/6 text-left text-gray-300 ">{item.display_name ?? item.material_name}</div>

            <div className="w-1/6 text-sm text-center">{itemDueDate().format("MM/DD/YY")}</div>
        </div>
    );
};

export default DashboardProcurementChecklistItem;
